import { getTeamCredits } from "../../services/billing";

export const useBillingHook = () => {
  const fetchTeamCredits = async () => {
    const selectedTeam = localStorage.getItem("selectedTeam");
    let teamId = "";

    if (selectedTeam) {
      try {
        const parsedTeam = JSON.parse(selectedTeam);
        teamId = parsedTeam.currentTeamId;
      } catch (err) {
        console.error("Error parsing selected team from localStorage:", err);
        return;
      }
    }

    if (teamId) {
      try {
        const response: any = await getTeamCredits(teamId);

        if (response && response?.success && response?.data) {
          return {
            credits: response?.data?.credits || 0,
            creditThreshold: response?.data?.credit_threshold ?? 10,
          };
        }
      } catch (err: any) {
        console.error("Error fetching team credits:", err);
        return 0;
      }
    }
  };

  return {
    fetchTeamCredits,
  };
};

export default useBillingHook;
